<template>
  <div>
    <button-component
      direction="back"
      value="Back" />
    &nbsp;&nbsp;
    <button 
      v-if="isAbstain"
      type="button" 
      class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
      @click="showAbstainModal">
      NEXT STEP
    </button>
    <button-component
      v-else
      :is-disabled="isDisabled"
      color="primary"
      value="Next Step" />
  </div>
</template>

<script>
import ButtonComponent from '@/components/Button.vue';

export default {
  name: 'ReviewButtons',
  components: {
    ButtonComponent
  },
  props: {
    isAbstain: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showAbstainModal() {
      this.$emit('show-abstain-modal');
    }
  }
};
</script>

<style scoped>

</style>